import { AddVersionWithPathRequest } from './add.version.with.path.request';

export class UpdateVersionWithPathRequest extends AddVersionWithPathRequest {
    VersionID: number;
}
